<template>
  <require from="framework/html_behaviors/af-popover"></require>

  <div class="info-box">
    <div if.bind="data" class="info-box-summary info-box-summary-with-details" af-popover="view.bind: 'components/mobile_app_dashboard/active-users-box-details.html'; model.bind: data.activeUsers; options.bind: { trigger: 'click', placement: 'bottom', theme: 'light-border' }">
      <div class="info-box-caption">Active Users</div>
      <div class="info-box-headline" title.bind="headlineTitle"><i class="fas fa-users"></i><span class="ml-2">${ data.headerActiveUsers.usersCount }</span></div>
    </div>
    <div else class="info-box-summary info-box-summary-with-details">
      <div class="info-box-caption">Active Users</div>
      <div class="info-box-spinner" title="loading"><i class="fas fa-spinner sc-spin"></i></div>
    </div>
  </div>
</template>
